module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-white-01-1200x2490.19b9c60e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-white-01-1200x2490.jpg
// module id = 1103
// module chunks = 37